import React from 'react';
import { bool, func, string } from 'prop-types';
import { intlShape } from 'react-intl';
import classNames from 'classnames';

import { NamedLink, SecondaryButton } from '../../../../../components';

import css from './ActionButton.module.css';

const ActionButton = (props) => {
  const {
    className,
    handleShowDetails,
    intl,
    isEnquire,
    isExpired,
    isMobile,
    isOrder,
    listingSlug,
    listingUuid,
    showDetails,
    transactionUuid,
  } = props;
  const shouldShowBookLink = isMobile && isEnquire && isOrder;
  const bookText = intl.formatMessage({ id: 'InboxPage.book' });
  const detailsText = intl.formatMessage({
    id: isMobile
      ? 'InboxPage.details'
      : showDetails
      ? 'InboxPage.hideDetails'
      : 'InboxPage.showDetails',
  });
  const classes = classNames(css.root, className);
  const linkProps = {
    name: isExpired ? 'ListingPage' : 'OrderDetailsPage',
    params: {
      id: isExpired ? listingUuid : transactionUuid,
      ...(isExpired && { slug: listingSlug }),
    },
    ...(!isExpired && { to: { search: '?book=true' } }),
  };

  return (
    <div className={classes}>
      {shouldShowBookLink ? (
        <NamedLink className={css.bookLink} {...linkProps}>
          {bookText}
        </NamedLink>
      ) : (
        <SecondaryButton
          className={css.detailsButton}
          onClick={() => handleShowDetails((prev) => !prev)}
        >
          {detailsText}
        </SecondaryButton>
      )}
    </div>
  );
};

ActionButton.defaultProps = {
  className: null,
};

ActionButton.propTypes = {
  className: string,
  handleShowDetails: func.isRequired,
  intl: intlShape.isRequired,
  isEnquire: bool.isRequired,
  isExpired: bool.isRequired,
  isMobile: bool.isRequired,
  isOrder: bool.isRequired,
  listingSlug: string.isRequired,
  listingUuid: string.isRequired,
  showDetails: bool.isRequired,
  transactionUuid: string.isRequired,
};

export default ActionButton;
